import React from 'react'
import { Link } from "react-router-dom";

export default function RegistrationGroup(props) {
    document.title = props.title
    const queryParameters = new URLSearchParams(window.location.search);
    const organizationCode = queryParameters.get("orgcode")?.toUpperCase() || props.orgCode;
    return (
        <div className='my-3 container container-group-body'>
            <Link to={`/student/ezregistration?orgcode=${organizationCode}`}><div className="box-container">Registration</div></Link>
            {/* <Link to={`/instructor/registration?orgcode=${organizationCode}`}> <div className="box-container">Registration as Instructor or Teacher</div> </Link> */}
            <Link to={`/school/registration?orgcode=${organizationCode}`}> <div className="box-container">Registration With School</div></Link>
        </div>
    )
}